import * as React from "react";

function SvgSheldon(props) {
  return (
    <svg
      fill="none"
      height={361}
      viewBox="0 0 230 361"
      width={230}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <filter
        id="Sheldon_svg__f"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={84}
        width={22}
        x={104.41}
        y={243.24}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.945098 0 0 0 0 0.352941 0 0 0 0 0.141176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="Sheldon_svg__P"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={50.78}
        width={27.458}
        x={101.519}
        y={279.539}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation={4} />
      </filter>
      <filter
        id="Sheldon_svg__Q"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={55.679}
        width={152.678}
        x={77}
        y={302.238}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-3} dy={-2} />
        <feGaussianBlur stdDeviation={7} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.945098 0 0 0 0 0.352941 0 0 0 0 0.141176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="Sheldon_svg__S"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={46}
        width={132}
        x={90}
        y={308}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation={2.5} />
      </filter>
      <filter
        id="Sheldon_svg__T"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={38.523}
        width={62.279}
        x={167.537}
        y={319.18}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-5} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.945098 0 0 0 0 0.352941 0 0 0 0 0.141176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="Sheldon_svg__U"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={33.154}
        width={55.545}
        x={150.695}
        y={319.449}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation={2} />
      </filter>
      <filter
        id="Sheldon_svg__V"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={55.679}
        width={152.678}
        x={14}
        y={305}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-3} dy={-2} />
        <feGaussianBlur stdDeviation={7} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.945098 0 0 0 0 0.352941 0 0 0 0 0.141176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="Sheldon_svg__X"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={46}
        width={132}
        x={27}
        y={310.762}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation={2.5} />
      </filter>
      <filter
        id="Sheldon_svg__Y"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={38.523}
        width={62.279}
        x={104.537}
        y={321.942}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx={-5} />
        <feGaussianBlur stdDeviation={8} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.945098 0 0 0 0 0.352941 0 0 0 0 0.141176 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow" />
      </filter>
      <filter
        id="Sheldon_svg__Z"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={33.154}
        width={55.545}
        x={87.695}
        y={322.211}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation={2} />
      </filter>
      <filter
        id="Sheldon_svg__ab"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height={81.742}
        width={31.366}
        x={42}
        y={257.284}
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur" stdDeviation={4} />
      </filter>
      <linearGradient id="Sheldon_svg__a">
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.477} stopColor="#a25400" />
        <stop offset={0.64} stopColor="#a25d00" />
        <stop offset={0.908} stopColor="#e7ad00" />
        <stop offset={0.951} stopColor="#eedb0e" />
        <stop offset={1} stopColor="#f7b81e" />
      </linearGradient>
      <linearGradient
        id="Sheldon_svg__d"
        gradientUnits="userSpaceOnUse"
        x1={186.48}
        x2={173.088}
        xlinkHref="#Sheldon_svg__a"
        y1={96.038}
        y2={75.707}
      />
      <linearGradient
        id="Sheldon_svg__e"
        gradientUnits="userSpaceOnUse"
        x1={5.284}
        x2={4.149}
        xlinkHref="#Sheldon_svg__a"
        y1={58.828}
        y2={82.203}
      />
      <linearGradient
        id="Sheldon_svg__g"
        gradientUnits="userSpaceOnUse"
        x1={115}
        x2={111.5}
        y1={279.5}
        y2={315.5}
      >
        <stop offset={0} stopColor="#f15a24" />
        <stop offset={0.994} stopColor="#e29734" />
      </linearGradient>
      <radialGradient
        id="Sheldon_svg__h"
        cx={0}
        cy={0}
        gradientTransform="matrix(282.35816 -4.62277 4.60226 281.10533 28.142 65.42)"
        gradientUnits="userSpaceOnUse"
        r={1}
      >
        <stop offset={0.317} stopColor="#fff" />
        <stop offset={0.862} stopColor="#999" />
        <stop offset={0.964} stopColor="#b3b3b3" />
      </radialGradient>
      <linearGradient
        id="Sheldon_svg__i"
        gradientUnits="userSpaceOnUse"
        x1={161.525}
        x2={142.795}
        xlinkHref="#Sheldon_svg__a"
        y1={97.648}
        y2={116.288}
      />
      <linearGradient
        id="Sheldon_svg__j"
        gradientUnits="userSpaceOnUse"
        x1={173.076}
        x2={151.387}
        xlinkHref="#Sheldon_svg__a"
        y1={113.039}
        y2={112.185}
      />
      <linearGradient
        id="Sheldon_svg__k"
        gradientUnits="userSpaceOnUse"
        x1={165.729}
        x2={148.022}
        xlinkHref="#Sheldon_svg__a"
        y1={114.874}
        y2={114.177}
      />
      <linearGradient
        id="Sheldon_svg__l"
        gradientUnits="userSpaceOnUse"
        x1={181.442}
        x2={160.839}
        xlinkHref="#Sheldon_svg__a"
        y1={103.165}
        y2={105.231}
      />
      <linearGradient
        id="Sheldon_svg__m"
        gradientUnits="userSpaceOnUse"
        x1={174.8}
        x2={157.98}
        xlinkHref="#Sheldon_svg__a"
        y1={106.422}
        y2={108.109}
      />
      <linearGradient
        id="Sheldon_svg__n"
        gradientUnits="userSpaceOnUse"
        x1={189.449}
        x2={168.846}
        xlinkHref="#Sheldon_svg__a"
        y1={94.438}
        y2={96.504}
      />
      <linearGradient
        id="Sheldon_svg__o"
        gradientUnits="userSpaceOnUse"
        x1={182.807}
        x2={165.985}
        xlinkHref="#Sheldon_svg__a"
        y1={97.694}
        y2={99.381}
      />
      <linearGradient
        id="Sheldon_svg__p"
        gradientUnits="userSpaceOnUse"
        x1={196.141}
        x2={176.05}
        xlinkHref="#Sheldon_svg__a"
        y1={84.969}
        y2={88.127}
      />
      <linearGradient
        id="Sheldon_svg__q"
        gradientUnits="userSpaceOnUse"
        x1={189.852}
        x2={173.448}
        xlinkHref="#Sheldon_svg__a"
        y1={88.814}
        y2={91.393}
      />
      <linearGradient
        id="Sheldon_svg__r"
        gradientUnits="userSpaceOnUse"
        x1={182.477}
        x2={182.749}
        xlinkHref="#Sheldon_svg__a"
        y1={68.759}
        y2={82.806}
      />
      <linearGradient
        id="Sheldon_svg__s"
        gradientUnits="userSpaceOnUse"
        x1={62.967}
        x2={58.812}
        y1={255.472}
        y2={261.703}
      >
        <stop offset={0} stopColor="gray" />
        <stop offset={1} stopColor="#b3b3b3" />
      </linearGradient>
      <radialGradient
        id="Sheldon_svg__t"
        cx={0}
        cy={0}
        gradientTransform="matrix(12.49996 1 -1 12.49996 146.5 115.5)"
        gradientUnits="userSpaceOnUse"
        r={1}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.401} stopColor="#a25400" />
        <stop offset={0.609} stopColor="#a25d00" />
        <stop offset={0.844} stopColor="#e7ad00" />
        <stop offset={0.974} stopColor="#eedb0e" />
        <stop offset={1} stopColor="#f7b81e" />
      </radialGradient>
      <radialGradient
        id="Sheldon_svg__u"
        cx={0}
        cy={0}
        gradientTransform="matrix(69.44953 -17.85978 18.76884 72.98452 157.527 193.245)"
        gradientUnits="userSpaceOnUse"
        r={1}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.651} stopColor="#a25d00" />
        <stop offset={0.771} stopColor="#a25400" />
        <stop offset={0.906} stopColor="#e7ad00" />
        <stop offset={0.951} stopColor="#ffd673" />
        <stop offset={1} stopColor="#f7b81e" />
      </radialGradient>
      <radialGradient
        id="Sheldon_svg__v"
        cx={0}
        cy={0}
        gradientTransform="matrix(52.20736 -13.42565 14.49244 56.3557 159.214 191.292)"
        gradientUnits="userSpaceOnUse"
        r={1}
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.515} stopColor="#fdfdfd" />
        <stop offset={0.7} stopColor="#f6f6f6" />
        <stop offset={0.833} stopColor="#ebebeb" />
        <stop offset={0.939} stopColor="#dadada" />
        <stop offset={1} stopColor="#ccc" />
      </radialGradient>
      <linearGradient id="Sheldon_svg__b">
        <stop offset={0} stopColor="#fff" />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="Sheldon_svg__w"
        gradientUnits="userSpaceOnUse"
        x1={169.821}
        x2={180.377}
        xlinkHref="#Sheldon_svg__b"
        y1={167.815}
        y2={176.244}
      />
      <linearGradient
        id="Sheldon_svg__x"
        gradientUnits="userSpaceOnUse"
        x1={144.666}
        x2={150.727}
        xlinkHref="#Sheldon_svg__b"
        y1={189.478}
        y2={178.185}
      />
      <linearGradient
        id="Sheldon_svg__y"
        gradientUnits="userSpaceOnUse"
        x1={116.33}
        x2={135.087}
        xlinkHref="#Sheldon_svg__a"
        y1={125.58}
        y2={106.932}
      />
      <linearGradient
        id="Sheldon_svg__z"
        gradientUnits="userSpaceOnUse"
        x1={126.359}
        x2={141.673}
        xlinkHref="#Sheldon_svg__a"
        y1={123.106}
        y2={107.88}
      />
      <linearGradient
        id="Sheldon_svg__A"
        gradientUnits="userSpaceOnUse"
        x1={98.95}
        x2={120.358}
        xlinkHref="#Sheldon_svg__a"
        y1={121.877}
        y2={106.343}
      />
      <linearGradient
        id="Sheldon_svg__B"
        gradientUnits="userSpaceOnUse"
        x1={109.242}
        x2={126.719}
        xlinkHref="#Sheldon_svg__a"
        y1={120.977}
        y2={108.296}
      />
      <linearGradient
        id="Sheldon_svg__C"
        gradientUnits="userSpaceOnUse"
        x1={82.87}
        x2={104.277}
        xlinkHref="#Sheldon_svg__a"
        y1={118.937}
        y2={103.404}
      />
      <linearGradient
        id="Sheldon_svg__D"
        gradientUnits="userSpaceOnUse"
        x1={93.161}
        x2={110.639}
        xlinkHref="#Sheldon_svg__a"
        y1={118.038}
        y2={105.356}
      />
      <linearGradient
        id="Sheldon_svg__E"
        gradientUnits="userSpaceOnUse"
        x1={67.764}
        x2={90.156}
        xlinkHref="#Sheldon_svg__a"
        y1={114.66}
        y2={100.582}
      />
      <linearGradient
        id="Sheldon_svg__F"
        gradientUnits="userSpaceOnUse"
        x1={78.091}
        x2={96.374}
        xlinkHref="#Sheldon_svg__a"
        y1={114.447}
        y2={102.953}
      />
      <linearGradient
        id="Sheldon_svg__G"
        gradientUnits="userSpaceOnUse"
        x1={52.452}
        x2={75.254}
        xlinkHref="#Sheldon_svg__a"
        y1={110.023}
        y2={96.62}
      />
      <linearGradient
        id="Sheldon_svg__H"
        gradientUnits="userSpaceOnUse"
        x1={62.781}
        x2={81.399}
        xlinkHref="#Sheldon_svg__a"
        y1={110.118}
        y2={99.175}
      />
      <linearGradient
        id="Sheldon_svg__I"
        gradientUnits="userSpaceOnUse"
        x1={36.537}
        x2={61.134}
        xlinkHref="#Sheldon_svg__a"
        y1={102.117}
        y2={92.39}
      />
      <linearGradient
        id="Sheldon_svg__J"
        gradientUnits="userSpaceOnUse"
        x1={46.729}
        x2={66.81}
        xlinkHref="#Sheldon_svg__a"
        y1={103.803}
        y2={95.862}
      />
      <linearGradient
        id="Sheldon_svg__K"
        gradientUnits="userSpaceOnUse"
        x1={21.691}
        x2={46.288}
        xlinkHref="#Sheldon_svg__a"
        y1={95.274}
        y2={85.548}
      />
      <linearGradient
        id="Sheldon_svg__L"
        gradientUnits="userSpaceOnUse"
        x1={31.883}
        x2={51.965}
        xlinkHref="#Sheldon_svg__a"
        y1={96.961}
        y2={89.02}
      />
      <linearGradient
        id="Sheldon_svg__M"
        gradientUnits="userSpaceOnUse"
        x1={8.122}
        x2={33.31}
        xlinkHref="#Sheldon_svg__a"
        y1={87.379}
        y2={79.306}
      />
      <linearGradient
        id="Sheldon_svg__N"
        gradientUnits="userSpaceOnUse"
        x1={18.179}
        x2={38.744}
        xlinkHref="#Sheldon_svg__a"
        y1={89.739}
        y2={83.147}
      />
      <linearGradient
        id="Sheldon_svg__O"
        gradientUnits="userSpaceOnUse"
        x1={8.453}
        x2={26.454}
        xlinkHref="#Sheldon_svg__a"
        y1={84.971}
        y2={81.984}
      />
      <linearGradient id="Sheldon_svg__c">
        <stop offset={0} stopColor="#f7b81e" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="Sheldon_svg__R"
        gradientUnits="userSpaceOnUse"
        x1={154.839}
        x2={154.839}
        xlinkHref="#Sheldon_svg__c"
        y1={305}
        y2={357.917}
      />
      <linearGradient
        id="Sheldon_svg__W"
        gradientUnits="userSpaceOnUse"
        x1={91.839}
        x2={91.839}
        xlinkHref="#Sheldon_svg__c"
        y1={307.762}
        y2={360.679}
      />
      <linearGradient
        id="Sheldon_svg__aa"
        gradientUnits="userSpaceOnUse"
        x1={66.462}
        x2={57.662}
        y1={238.151}
        y2={327.5}
      >
        <stop offset={0.094} />
        <stop offset={0.406} stopColor="#f15a24" />
        <stop offset={0.865} stopColor="#e29734" />
        <stop offset={1} stopColor="#f7b81e" />
      </linearGradient>
      <path
        d="M173.14 77.06l.39-1.3c.65-2.16 2.63-3.47 4.41-2.93l4.85 1.47c1.79.54 2.71 2.73 2.06 4.88l-.39 1.3c-.65 2.16-2.63 3.47-4.42 2.93l-4.85-1.47c-1.78-.53-2.7-2.72-2.05-4.88zm6.39 3.74c.9.27 1.91-.39 2.23-1.48l.2-.66c.33-1.09-.14-2.2-1.04-2.47l-2.45-.74c-.9-.27-1.9.39-2.23 1.48l-.2.66c-.33 1.09.13 2.19 1.04 2.47z"
        fill="url(#Sheldon_svg__d)"
      />
      <path
        d="M20.84 72.58c.31-.62 1.71-.55 3.12.16 1.42.71 2.32 1.78 2.01 2.4l-4.1 8.22c-.31.62-1.71.55-3.12-.16-1.42-.7-2.32-1.78-2.01-2.4z"
        fill="url(#Sheldon_svg__e)"
      />
      <g filter="url(#Sheldon_svg__f)">
        <path d="M113.41 243.24l-9 84 22-2-2-82z" fill="url(#Sheldon_svg__g)" />
      </g>
      <path
        d="M200.86 172.07c0 61.89-44.96 112.07-100.43 112.07S0 233.96 0 172.07C0 110.17 44.96 0 100.43 0s100.43 110.17 100.43 172.07z"
        fill="#fff"
      />
      <path
        d="M202.868 168.995C205.671 229.96 160.5 281.444 104.5 284 49.62 286.504 6.943 239.012 4.14 178.056 1.337 117.09 40.835 6.538 95.714 4.043c54.88-2.504 104.351 103.986 107.154 164.952z"
        fill="url(#Sheldon_svg__h)"
        opacity={0.46}
      />
      <path
        d="M139.85 111.56l-.01 1.33a3.999 3.999 0 003.98 4.02l6 .03c2.21.01 4.01-1.77 4.02-3.98l.01-1.33a3.999 3.999 0 00-3.98-4.02l-6-.03a3.999 3.999 0 00-4.02 3.98zm8.52-1.65c1.12.01 2.02.92 2.01 2.03v.67a2.02 2.02 0 01-2.03 2.01l-3.04-.02a2.02 2.02 0 01-2.01-2.03v-.67c0-1.12.92-2.02 2.03-2.01z"
        fill="url(#Sheldon_svg__i)"
      />
      <path
        d="M152.52 109.84l-.73-1.11c-1.21-1.85-1.13-4.05.18-4.92l3.57-2.37c1.31-.87 3.36-.08 4.58 1.76l.73 1.11c1.21 1.85 1.13 4.05-.18 4.92l-3.57 2.37c-1.32.88-3.37.09-4.58-1.76zm5.99-1.94c.66-.44.71-1.56.09-2.49l-.37-.56c-.61-.93-1.65-1.33-2.32-.89l-1.8 1.2c-.66.44-.71 1.56-.09 2.49l.37.56c.61.93 1.65 1.33 2.31.89z"
        fill="url(#Sheldon_svg__j)"
      />
      <path
        d="M156.14 108.64c.49-.33.52-1.15.07-1.84-.46-.69-1.22-.99-1.72-.66l-6.54 4.34c-.49.33-.52 1.15-.07 1.85.46.69 1.22.99 1.72.66z"
        fill="url(#Sheldon_svg__k)"
      />
      <path
        d="M161.68 103.64l-.85-1.02c-1.4-1.69-1.64-3.99-.53-5.13l3.02-3.11c1.11-1.15 3.15-.7 4.55.98l.85 1.02c1.4 1.69 1.64 3.99.53 5.13l-3.02 3.11c-1.12 1.15-3.15.71-4.55-.98zm5.35-3.12c.56-.58.44-1.74-.27-2.6l-.43-.52c-.71-.85-1.74-1.08-2.3-.5l-1.53 1.57c-.56.58-.44 1.74.27 2.6l.43.52c.71.86 1.74 1.08 2.3.5z"
        fill="url(#Sheldon_svg__l)"
      />
      <path
        d="M164.91 101.73c.42-.43.33-1.29-.2-1.92s-1.29-.8-1.71-.37l-5.53 5.7c-.42.43-.33 1.29.2 1.93.52.63 1.29.8 1.71.37z"
        fill="url(#Sheldon_svg__m)"
      />
      <path
        d="M169.68 94.92l-.85-1.02c-1.4-1.69-1.64-3.99-.53-5.13l3.02-3.11c1.11-1.15 3.15-.71 4.55.98l.85 1.02c1.4 1.69 1.64 3.99.53 5.13l-3.02 3.11c-1.11 1.15-3.15.71-4.55-.98zm5.36-3.12c.56-.58.44-1.74-.27-2.6l-.43-.52c-.71-.86-1.74-1.08-2.3-.5l-1.53 1.57c-.56.58-.44 1.74.27 2.6l.43.52c.71.85 1.74 1.08 2.3.5z"
        fill="url(#Sheldon_svg__n)"
      />
      <path
        d="M172.91 93c.42-.43.33-1.29-.2-1.92s-1.29-.8-1.71-.37l-5.53 5.7c-.42.43-.33 1.29.2 1.93.53.63 1.29.8 1.71.37z"
        fill="url(#Sheldon_svg__o)"
      />
      <path
        d="M176.86 87.03l-.89-.97c-1.47-1.61-1.84-3.93-.83-5.19l2.76-3.41c1.02-1.25 3.03-.97 4.51.64l.89.97c1.47 1.61 1.84 3.93.83 5.19l-2.76 3.41c-1.02 1.25-3.04.97-4.51-.64zm5.04-3.61c.51-.64.33-1.81-.42-2.62l-.45-.49c-.75-.81-1.77-.96-2.28-.32l-1.39 1.72c-.51.63-.33 1.81.42 2.62l.45.49c.74.81 1.76.96 2.28.32z"
        fill="url(#Sheldon_svg__p)"
      />
      <path
        d="M179.9 84.82c.38-.47.24-1.34-.31-1.94s-1.31-.71-1.69-.24l-5.05 6.25c-.38.47-.24 1.34.31 1.94s1.31.71 1.69.24z"
        fill="url(#Sheldon_svg__q)"
      />
      <path
        d="M183.52 76.41c.35-.35 1.11-.15 1.69.44s.78 1.34.43 1.69l-4.62 4.6c-.35.35-1.11.15-1.69-.44s-.78-1.34-.43-1.69z"
        fill="url(#Sheldon_svg__r)"
      />
      <path
        d="M52.51 231.49l-9.74 18.82s8.36 10.62 19.5 13.28c11.15 2.65 18.39 1.34 18.39 1.34l-2.98-27.07s-14.08 6.62-25.17-6.37z"
        fill="#000"
      />
      <path
        d="M63.81 259.43c-9.14-1.96-16.59-8.27-19.85-11.44l-1.2 2.31s8.36 10.62 19.5 13.28c11.15 2.65 18.39 1.34 18.39 1.34l-.42-3.85c-3.53.1-9.24-.1-16.42-1.64z"
        fill="url(#Sheldon_svg__s)"
      />
      <path
        d="M158.25 114.4c-2.22-8.65-9.55-14.25-16.35-12.5s-10.52 10.18-8.29 18.83c2.22 8.65 9.55 14.25 16.35 12.5 6.81-1.75 10.52-10.18 8.29-18.83zm-11.1 10.27c-4.12 1.06-7.26-1.34-8.47-6.04s.34-9.17 4.46-10.23 8.07 1.14 9.28 5.84c1.2 4.7-1.16 9.37-5.27 10.43z"
        fill="url(#Sheldon_svg__t)"
      />
      <path
        d="M227.39 176.99c10.6 41.19-12.6 82.76-51.79 92.84-39.2 10.08-79.56-15.14-90.15-56.33s12.6-82.75 51.79-92.83c39.19-10.09 79.55 15.13 90.15 56.32z"
        fill="url(#Sheldon_svg__u)"
      />
      <path
        d="M211.42 177.87c8 31.13-8.88 62.37-37.71 69.78-28.83 7.42-58.69-11.81-66.7-42.93-8-31.12 8.88-62.37 37.71-69.78 28.83-7.42 58.69 11.8 66.7 42.93z"
        fill="url(#Sheldon_svg__v)"
      />
      <g fill="#000">
        <path d="M157.26 133.34c-.5 0-1.01.01-1.51.02l.18 6.05c.44-.01.89-.02 1.33-.02zM136 138.05l-.51.24c-.01 0-.01.01-.02.01-.01.01-.03.01-.04.02 0 0-.01 0-.01.01h-.01c-.01 0-.01 0-.02.01-.01 0-.01.01-.02.01-.24.12-.49.24-.73.36l2.72 5.41c.4-.2.79-.39 1.2-.58zm-17.32 13.22l-.15.18c0 .01-.01.01-.01.02l-.01.01v.01l-.01.01v.01l-.01.01v.01l-.01.01c0 .01-.01.01-.01.02v.01l-.01.01-.01.01-.01.01-.01.01s0 .01-.01.01l-.01.01-.01.01-.01.01v.01l-.01.01c-.02.02-.03.04-.05.06 0 .01-.01.01-.01.01 0 .01-.01.01-.01.01 0 .01-.01.01-.01.01-.19.22-.37.44-.55.67l4.71 3.81c.28-.35.57-.69.86-1.03zm-10.66 19.03c-.16.48-.31.96-.46 1.44l5.8 1.75c.13-.43.27-.87.41-1.29zm3.11 21.35l-6.05.28c.01.13.01.26.02.39v.28c.02.28.03.55.05.83l6.04-.42c-.01-.45-.04-.91-.06-1.36zm4.32 19.27l-5.59 2.32c.19.47.39.93.6 1.39l5.53-2.46c-.19-.41-.37-.83-.54-1.25zm10.65 16.52l-4.41 4.15.15.15.01.01.01.01s0 .01.01.01l.03.03c.23.24.46.48.69.71l.01.01.04.04.01.01.01.01.02.02.01.01.01.01.01.01.01.01.01.01.01.01.01.01 4.3-4.26c-.32-.32-.64-.64-.95-.97zm15.79 11.44l-2.54 5.5c.01 0 .02.01.03.01 0 0 .01 0 .01.01h.01c.44.2.89.4 1.34.59l2.38-5.57c-.41-.17-.82-.35-1.23-.54zm20.11 4.3c-.28.01-.55.01-.83.01h-.5l-.07 6.05H161.42c.23 0 .47 0 .7-.01zm18.62-4.49l-1.2.57 2.49 5.52c.16-.07.32-.14.47-.22.01 0 .01 0 .02-.01h.01s.01 0 .01-.01h.02s.01 0 .01-.01h.01s.01 0 .01-.01c.27-.13.54-.25.8-.38zm15.07-11.95c-.29.35-.58.69-.87 1.02l4.56 3.99.9-1.05.01-.01v-.01l.01-.01.01-.01s0-.01.01-.01l.01-.01.01-.01.01-.01c0-.01.01-.01.01-.02zm9.22-17.15l-.42 1.29 5.73 1.95c.16-.48.32-.96.47-1.44zm8.38-19.87l-6.04.37c.03.46.05.91.07 1.36l6.05-.22c-.01-.37-.03-.74-.05-1.11v-.02-.02-.01-.02-.01-.02-.01-.02-.01-.08-.07-.01c-.02-.03-.02-.06-.03-.1zm-5.09-21.24l-5.56 2.41c.18.42.36.84.53 1.26l5.61-2.27c-.18-.47-.38-.94-.58-1.4zm-12.11-18.16l-4.34 4.22c.32.32.63.65.93.99l4.45-4.1c-.34-.38-.69-.75-1.04-1.11zm-17.88-12.5l-2.44 5.54c.41.18.82.37 1.22.56l2.59-5.47c-.45-.22-.9-.43-1.37-.63zm-20.95-4.48v6.05c.34 0 .67 0 1.01.01l.14-6.05c-.39 0-.77-.01-1.15-.01zM150.62 142.57l-2.02 6.79-5.36-4.89-.8-9.76 4.17-1.07zM167.62 239.25l2.01-6.79 5.36 4.9.8 9.75-4.17 1.08zM204.04 183.6l-6.43-2.4 4.38-5.56 9.11-.49 1.15 4.5zM114.21 198l6.43 2.41-4.38 5.55-9.1.5-1.16-4.5z" />
        <path d="M203.16 180.18l-5.59.87 5.3-1.99 8.72-1.98.17.63zM193.74 146.31l-13.56 8.63s-7.01 2.85-.53 7.78l-24.22 25.25-.14 10.34 8.75-1.68 18.89-31.73s5.76 5.9 7.29-3.24z" />
      </g>
      <path
        d="M194.06 146.58l-13.14 8.59s-6.76 2.89-.64 7.53l-23.66 24.91-.3 10 8.41-1.78 18.66-31.08s5.42 5.59 7.04-3.27z"
        fill="url(#Sheldon_svg__w)"
        opacity={0.2}
      />
      <path
        d="M127.24 172.84l8.05 10.89s2.95 5.94 5.93-1l19.14 16 7.8-1.86-2.26-7.77-23.41-9.83s3.78-6.46-3.28-6.12z"
        fill="#000"
      />
      <path
        d="M127.4 172.49l7.98 10.5s2.95 5.7 5.75-.86l18.83 15.55 7.57-1.64-2.31-7.44-22.9-9.74s3.59-6.09-3.27-5.89z"
        fill="url(#Sheldon_svg__x)"
        opacity={0.2}
      />
      <path
        d="M138.02 111.68l.01-1.33a3.999 3.999 0 00-3.98-4.02l-6-.03a3.999 3.999 0 00-4.02 3.98l-.01 1.33a3.999 3.999 0 003.98 4.02l6 .03c2.21.01 4.01-1.77 4.02-3.98zm-8.53 1.64a2.02 2.02 0 01-2.01-2.03v-.68c.01-1.12.92-2.02 2.04-2.01l3.04.02c1.12.01 2.02.92 2.01 2.03v.68a2.023 2.023 0 01-2.04 2.01z"
        fill="url(#Sheldon_svg__y)"
      />
      <path
        d="M132.85 112.65c-.83 0-1.5-.68-1.49-1.51 0-.83.68-1.5 1.51-1.49l11 .06c.83 0 1.5.68 1.49 1.51 0 .83-.68 1.5-1.51 1.49z"
        fill="url(#Sheldon_svg__z)"
      />
      <path
        d="M122.52 111.48l.21-1.32a4.01 4.01 0 00-3.31-4.59l-5.92-.96a4.004 4.004 0 00-4.59 3.31l-.21 1.32a4.004 4.004 0 003.31 4.59l5.92.96c2.19.36 4.24-1.13 4.59-3.31zm-8.67.31a2.023 2.023 0 01-1.67-2.32l.11-.67c.18-1.1 1.22-1.85 2.32-1.67l3 .49c1.1.18 1.85 1.22 1.67 2.32l-.11.67a2.023 2.023 0 01-2.32 1.67z"
        fill="url(#Sheldon_svg__A)"
      />
      <path
        d="M117.27 111.64c-.82-.13-1.37-.9-1.24-1.72s.9-1.37 1.72-1.24l10.86 1.76c.82.13 1.37.9 1.24 1.72s-.9 1.37-1.72 1.24z"
        fill="url(#Sheldon_svg__B)"
      />
      <path
        d="M106.44 108.54l.21-1.32a4.01 4.01 0 00-3.31-4.59l-5.92-.96a4.004 4.004 0 00-4.59 3.31l-.21 1.32a4.004 4.004 0 003.31 4.59l5.92.96c2.19.36 4.24-1.13 4.59-3.31zm-8.67.32a2.023 2.023 0 01-1.67-2.32l.11-.67c.18-1.1 1.22-1.85 2.32-1.67l3 .48c1.1.18 1.85 1.22 1.67 2.32l-.11.67a2.023 2.023 0 01-2.32 1.67z"
        fill="url(#Sheldon_svg__C)"
      />
      <path
        d="M101.19 108.7c-.82-.13-1.37-.9-1.24-1.72s.9-1.37 1.72-1.24l10.86 1.76c.82.13 1.37.9 1.24 1.72s-.9 1.37-1.72 1.24z"
        fill="url(#Sheldon_svg__D)"
      />
      <path
        d="M91.98 105.85l.3-1.3c.5-2.15-.84-4.3-3-4.8l-5.85-1.35c-2.15-.5-4.3.85-4.8 3l-.3 1.3c-.5 2.15.84 4.3 3 4.8l5.85 1.35c2.15.5 4.3-.84 4.8-3zm-8.68-.26a2.028 2.028 0 01-1.52-2.43l.15-.66a2.028 2.028 0 012.43-1.52l2.96.68c1.09.25 1.77 1.34 1.52 2.43l-.15.66a2.028 2.028 0 01-2.43 1.52z"
        fill="url(#Sheldon_svg__E)"
      />
      <path
        d="M86.72 105.67c-.81-.19-1.31-.99-1.12-1.8s.99-1.31 1.8-1.12l10.72 2.47c.81.19 1.31.99 1.12 1.8a1.49 1.49 0 01-1.8 1.12z"
        fill="url(#Sheldon_svg__F)"
      />
      <path
        d="M76.92 101.94l.34-1.29c.56-2.14-.72-4.32-2.85-4.88l-5.8-1.52c-2.14-.56-4.32.72-4.88 2.85l-.34 1.29c-.56 2.14.72 4.32 2.85 4.88l5.8 1.52c2.13.57 4.32-.71 4.88-2.85zm-8.67-.52a2.015 2.015 0 01-1.44-2.47l.17-.65a2.015 2.015 0 012.47-1.44l2.94.77c1.08.28 1.73 1.39 1.44 2.47l-.17.65a2.015 2.015 0 01-2.47 1.44z"
        fill="url(#Sheldon_svg__G)"
      />
      <path
        d="M71.67 101.6a1.5 1.5 0 01.76-2.9l10.64 2.79a1.5 1.5 0 01-.76 2.9z"
        fill="url(#Sheldon_svg__H)"
      />
      <path
        d="M61.96 97.91l.53-1.22c.88-2.02-.04-4.38-2.07-5.27l-5.5-2.4c-2.02-.88-4.38.04-5.27 2.06l-.53 1.22c-.88 2.02.04 4.38 2.07 5.27l5.5 2.4c2.02.89 4.38-.04 5.27-2.06zm-8.49-1.86a2.033 2.033 0 01-1.05-2.66l.27-.62a2.041 2.041 0 012.67-1.05l2.78 1.21a2.02 2.02 0 011.04 2.66l-.27.62a2.033 2.033 0 01-2.66 1.05z"
        fill="url(#Sheldon_svg__I)"
      />
      <path
        d="M56.82 96.76a1.487 1.487 0 01-.77-1.97c.33-.76 1.21-1.11 1.97-.77l10.08 4.4c.76.33 1.11 1.22.77 1.98-.33.76-1.21 1.11-1.97.77z"
        fill="url(#Sheldon_svg__J)"
      />
      <path
        d="M47.11 91.06l.53-1.22c.88-2.02-.04-4.38-2.07-5.27l-5.5-2.4c-2.02-.88-4.38.04-5.27 2.07l-.53 1.22c-.88 2.03.04 4.38 2.07 5.27l5.5 2.4c2.03.88 4.39-.04 5.27-2.07zm-8.48-1.85a2.02 2.02 0 01-1.04-2.66l.27-.62a2.02 2.02 0 012.66-1.04l2.78 1.21a2.02 2.02 0 011.04 2.66l-.27.62a2.033 2.033 0 01-2.66 1.05z"
        fill="url(#Sheldon_svg__K)"
      />
      <path
        d="M41.98 89.91a1.487 1.487 0 01-.77-1.97c.33-.76 1.21-1.11 1.97-.77l10.08 4.4c.76.33 1.11 1.22.77 1.98-.33.76-1.21 1.11-1.98.77z"
        fill="url(#Sheldon_svg__L)"
      />
      <path
        d="M33.76 84.87l.61-1.18c1.02-1.96.25-4.38-1.71-5.39l-5.33-2.76a3.994 3.994 0 00-5.39 1.71l-.61 1.18a3.994 3.994 0 001.71 5.39l5.33 2.76c1.96 1.01 4.38.25 5.39-1.71zm-8.34-2.42a2.033 2.033 0 01-.87-2.73l.31-.6c.51-.99 1.74-1.38 2.73-.87l2.7 1.4c.99.51 1.38 1.74.87 2.73l-.31.6c-.51.99-1.74 1.38-2.73.87z"
        fill="url(#Sheldon_svg__M)"
      />
      <path
        d="M28.72 83.38a1.496 1.496 0 01-.64-2.02c.38-.74 1.29-1.02 2.02-.64l9.77 5.06c.74.38 1.02 1.29.64 2.02-.38.74-1.29 1.02-2.02.64z"
        fill="url(#Sheldon_svg__N)"
      />
      <path
        d="M17.53 77.85c-.55-.28-.68-1.11-.3-1.84.38-.74 1.13-1.1 1.68-.82l7.27 3.77c.55.28.68 1.11.3 1.85s-1.13 1.1-1.68.82z"
        fill="url(#Sheldon_svg__O)"
      />
      <g filter="url(#Sheldon_svg__P)">
        <path
          d="M113.256 287.699l-3.737 34.621 11.458-1.141-1.981-33.64z"
          fill="#f7b81e"
        />
      </g>
      <g filter="url(#Sheldon_svg__Q)">
        <path
          d="M80 337.979c2.29 12.85 15.96 13.62 23.79 13.6s54.88-2.52 68.86.64c4.83 1.09 10.11 2.71 15.64 3.95 10.49 2.34 21.9 3.29 32.88-3.43.77-.47 1.48-.95 2.13-1.43 7.82-5.81 7.2-12.72 4.7-18.22-2.422-5.328-9.5-7.5-9.5-7.5 3.38-10.78-5-15.864-10.5-18.589-9.16-4.539-27.5-3.059-41.53 1.359-9.56 3.01-14.41 6.02-50.08 7.74-11.17.54-18.73 2.119-24.39 4.49-5.11 2.14-7.78 5.1-9.5 8-2.32 3.9-2.5 9.39-2.5 9.39z"
          fill="#e7ad00"
        />
        <path
          d="M80 337.979c2.29 12.85 15.96 13.62 23.79 13.6s54.88-2.52 68.86.64c4.83 1.09 10.11 2.71 15.64 3.95 10.49 2.34 21.9 3.29 32.88-3.43.77-.47 1.48-.95 2.13-1.43 7.82-5.81 7.2-12.72 4.7-18.22-2.422-5.328-9.5-7.5-9.5-7.5 3.38-10.78-5-15.864-10.5-18.589-9.16-4.539-27.5-3.059-41.53 1.359-9.56 3.01-14.41 6.02-50.08 7.74-11.17.54-18.73 2.119-24.39 4.49-5.11 2.14-7.78 5.1-9.5 8-2.32 3.9-2.5 9.39-2.5 9.39z"
          fill="url(#Sheldon_svg__R)"
        />
      </g>
      <g filter="url(#Sheldon_svg__S)">
        <path
          d="M95 335.436c1.867 8.742 13.009 9.266 19.391 9.252s44.731-1.714 56.126.435c3.937.742 8.241 1.844 12.748 2.688 8.55 1.592 17.851 2.238 26.8-2.334.628-.32 1.206-.646 1.736-.973 6.374-3.952 5.869-8.653 3.831-12.395-1.974-3.624-7.743-5.102-7.743-5.102 2.755-7.334-2.445-10.205-6.113-11.722-7.466-3.088-24.86-3.005-36.296 0-7.792 2.048-11.745 4.096-40.819 5.266-9.105.367-15.266 1.442-19.88 3.054-4.165 1.456-6.341 3.47-7.743 5.443-1.891 2.653-2.038 6.388-2.038 6.388z"
          fill="#f7b81e"
        />
      </g>
      <g filter="url(#Sheldon_svg__T)">
        <path
          d="M218.5 325c-16.5-8.839-33-6-39-2-13.5 7-5 29 5.5 32 17.788 5.082 39.447 4 44.5-12 1-3.167.2-12-11-18z"
          fill="#f7b81e"
        />
      </g>
      <g filter="url(#Sheldon_svg__U)">
        <path
          d="M194.074 328.198c-12.395-6.325-25.208-5.243-29.973-2.967-10.651 3.851-15.437 14.157 3.089 20.535 13.266 4.568 30.246 4.256 34.712-5.672.884-1.965.585-7.602-7.828-11.896z"
          fill="#f7b81e"
        />
      </g>
      <g filter="url(#Sheldon_svg__V)">
        <path
          d="M17 340.741c2.29 12.85 15.96 13.62 23.79 13.6s54.88-2.52 68.86.64c4.83 1.09 10.11 2.71 15.64 3.95 10.49 2.34 21.9 3.29 32.88-3.43.77-.47 1.48-.95 2.13-1.43 7.82-5.81 7.2-12.72 4.7-18.22-2.422-5.328-9.5-7.5-9.5-7.5 3.38-10.78-5-15.863-10.5-18.589-9.16-4.539-27.5-3.058-41.53 1.359-9.56 3.01-14.41 6.02-50.08 7.74-11.17.54-18.73 2.12-24.39 4.49-5.11 2.14-7.78 5.1-9.5 8-2.32 3.9-2.5 9.39-2.5 9.39z"
          fill="#e7ad00"
        />
        <path
          d="M17 340.741c2.29 12.85 15.96 13.62 23.79 13.6s54.88-2.52 68.86.64c4.83 1.09 10.11 2.71 15.64 3.95 10.49 2.34 21.9 3.29 32.88-3.43.77-.47 1.48-.95 2.13-1.43 7.82-5.81 7.2-12.72 4.7-18.22-2.422-5.328-9.5-7.5-9.5-7.5 3.38-10.78-5-15.863-10.5-18.589-9.16-4.539-27.5-3.058-41.53 1.359-9.56 3.01-14.41 6.02-50.08 7.74-11.17.54-18.73 2.12-24.39 4.49-5.11 2.14-7.78 5.1-9.5 8-2.32 3.9-2.5 9.39-2.5 9.39z"
          fill="url(#Sheldon_svg__W)"
        />
      </g>
      <g filter="url(#Sheldon_svg__X)">
        <path
          d="M32 338.198c1.867 8.742 13.009 9.266 19.39 9.252 6.383-.013 44.732-1.714 56.127.436 3.937.741 8.241 1.843 12.748 2.687 8.55 1.592 17.851 2.238 26.8-2.334a24.037 24.037 0 001.736-.973c6.374-3.952 5.869-8.653 3.831-12.395-1.974-3.624-7.743-5.102-7.743-5.102 2.755-7.334-2.445-10.205-6.113-11.722-7.466-3.088-24.86-3.005-36.296 0-7.792 2.048-11.745 4.096-40.82 5.266-9.104.367-15.265 1.442-19.879 3.054-4.165 1.456-6.341 3.47-7.743 5.443-1.891 2.653-2.038 6.388-2.038 6.388z"
          fill="#f7b81e"
        />
      </g>
      <g filter="url(#Sheldon_svg__Y)">
        <path
          d="M155.5 327.762c-16.5-8.839-33-6-39-2-13.5 7-5 29 5.5 32 17.788 5.083 39.447 4 44.5-12 1-3.166.2-12-11-18z"
          fill="#f7b81e"
        />
      </g>
      <g filter="url(#Sheldon_svg__Z)">
        <path
          d="M131.074 330.96c-12.395-6.325-25.208-5.243-29.973-2.967-10.651 3.851-15.437 14.157 3.089 20.536 13.266 4.568 30.246 4.255 34.712-5.673.884-1.965.585-7.602-7.828-11.896z"
          fill="#f7b81e"
        />
      </g>
      <path
        d="M58.474 242.966L44.442 332.8l22.672-.951 2.64-88.283z"
        fill="url(#Sheldon_svg__aa)"
      />
      <g filter="url(#Sheldon_svg__ab)">
        <path
          d="M58.846 265.284L50 331.026l13.124-.879 2.242-64.516z"
          fill="#f7b81e"
        />
      </g>
    </svg>
  );
}

const MemoSvgSheldon = React.memo(SvgSheldon);
export default MemoSvgSheldon;
